import { IconButton } from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useStyles } from "./MainTransparentBackButton.styles";
import { IMainTransparentBackButton } from "./MainTransparentBackButtonInterfaces";
import { useTranslation } from "react-i18next";

const MainTransparentBackButton = ({ onClick, icon, text }: IMainTransparentBackButton) => {
    const classes = useStyles();
    const { t } = useTranslation();
    return (
        <div className={classes.mainWrapper}>
            <IconButton className={classes.backButton} onClick={onClick}>
                {icon ? icon : <ArrowBackIosIcon />}
                {text ? text : t("main_transparent_back_button.back_button")}
            </IconButton>
        </div>
    );
};

export default MainTransparentBackButton;
